import { HttpErrorResponse, HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, throwError } from 'rxjs'
import { environment } from '../../../environments/environment'
import { VendorMemberModel } from './member-vendor.model'

const API_URL = environment.apiUrl

@Injectable({
  providedIn: 'root',
})
export class VendorMemberService {
  constructor(private http: HttpClient) {}

  addVendorMember(vendormember: VendorMemberModel) {
    
    return this.http.post(API_URL + '/VendorMember/CreateVendorMember', vendormember, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateVendorMember(vendormember: VendorMemberModel) {
    
    return this.http.put(API_URL + '/VendorMember/UpdateVendorMember', vendormember, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllVendorMembers(): Observable<VendorMemberModel[]> {
    return this.http.get(API_URL + '/VendorMember/ReadVendorMembers', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),

      catchError((error: any) => {
        

        

        return throwError(() => error);
      }),
    )
  }

  deleteVendorMember(vendormember: VendorMemberModel) {
    
    return this.http
      .delete(API_URL + '/VendorMember/DeleteVendorMember', {
        headers: {},
        body: vendormember,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
